import { useQuery } from "@tanstack/react-query";
import { useClientContext } from "clients";
import { useStateContext } from "state";

const useGetOrganization = (organization_id?: number) => {
  const clients = useClientContext();
  const state = useStateContext();
  const { data, isLoading, isSuccess, isError } = useQuery({
    queryKey: ["getOrganization", state.tokens?.user_id, organization_id],
    queryFn: async () => {
      if (!organization_id) {
        throw new Error("organization_id is required");
      }
      return await clients.management.getOrganizationDetails(organization_id);
    },
    staleTime: 2 * 60 * 100, // Data is fresh for 2 minutes
    enabled: !!organization_id,
  });

  return {
    data,
    isLoading,
    isSuccess,
    isError,
  };
};

export default useGetOrganization;
